import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { omit } from 'lodash';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { UserProfile, UserProfileResponse } from './api.user-profile.models';

export class UserProfileApi {
  private apiUrl: string = environment.API_URL;
  USER_PROFILE = '/user-profile/user-profiles';

  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getUserProfileById(id: string): Observable<UserProfile> {
    const url = `${this.apiUrl}${this.USER_PROFILE}/${id}`;
    return this.http.get<UserProfileResponse>(url).pipe(
      timeout(this.config.responseTimeout),
      map((res: UserProfileResponse) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  updateUserProfile(userId: string, newProfile: UserProfile): Observable<UserProfile> {
    const url = `${this.apiUrl}${this.USER_PROFILE}/${userId}`;
    const body = omit(newProfile, ['id']);
    return this.http.put<UserProfileResponse>(url, body).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }
}
